var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandle = function SvgHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.707 1.706A1 1 0 0 0 14.294.293l-14.001 14a1 1 0 1 0 1.413 1.414zm0 7.335a1 1 0 1 0-1.413-1.413l-6.666 6.666a1 1 0 0 0 1.413 1.413z",
    clipRule: "evenodd"
  })));
};
export default SvgHandle;